export default __webpack_public_path__ + "static/media/Logo.9e7a5aa0.png";